import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GetQoutesListResponse, QuoteDTO, SuccessDTO } from '../../interfaces/models';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class QuoteService {

  @Output() changeRequested = new EventEmitter<boolean>();

  constructor(
    protected httpClient: HttpClient,
  ) {
  }

  public getQouteList(
    offset: number = 0,
    limit: number = 10,
    order: string = null,
    orderBy: string = null,
  ): Observable<GetQoutesListResponse> {
    const orderUrl = order
      ? `&orderByDirection=${order.toLocaleUpperCase()}`
      : '';
    const orderByUrl = orderBy ? `&orderByField=${orderBy}` : '';
    return this.httpClient.get<GetQoutesListResponse>(
      `${environment.api}/quotes?offset=${offset}&limit=${limit}${orderUrl}${orderByUrl}`,
    );
  }

  public getQuoteExpiredList(
    offset: number = 0,
    limit: number = 10,
    order: string = null,
    orderBy: string = null,
  ): Observable<GetQoutesListResponse> {
    const orderUrl = order
      ? `&orderByDirection=${order.toLocaleUpperCase()}`
      : '';
    const orderByUrl = orderBy ? `&orderByField=${orderBy}` : '';
    return this.httpClient.get<GetQoutesListResponse>(
      `${environment.api}/quotes/search/expired?offset=${offset}&limit=${limit}${orderUrl}${orderByUrl}`,
    );
  }

  public offerrDiscount(data: {
    id: number;
    discount: number;
  }): Observable<QuoteDTO> {
    const { id, discount } = data;
    return this.httpClient.patch<QuoteDTO>(
      `${environment.api}/quotes/${id}/discount`,
      { discount },
    );
  }

  public deleteQuoteCompletely(id: number) {
    return this.httpClient.delete<SuccessDTO>(
      `${environment.api}/quotes/${id}/completely`,
    );
  }
}
